import { render, staticRenderFns } from "./DeleteQuestion.vue?vue&type=template&id=13a58210&"
import script from "./DeleteQuestion.vue?vue&type=script&lang=js&"
export * from "./DeleteQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports